import { LogDb } from 'lib/cosmos/log/logDb';

export type AppErrorBehavior = LogDb.LogBehavior;

export class AppError extends Error {
	readonly behavior: AppErrorBehavior;
	readonly internalLogMessage?: string;

	constructor(
		public readonly data: {
			readonly behavior: AppErrorBehavior;
			readonly message: string;
			readonly internalLogMessage?: string;
		}
	) {
		super(data.message);

		this.behavior = data.behavior;
		this.internalLogMessage = data.internalLogMessage;
	}
}
